<div class="center-content">
	<div *ngIf="isTestRunning">
		<div class="big-text">{{ 'workflow.akustischeReaktion.started' | translate }}</div>
		<div class="pictograms"><img src="assets/images/icons/AudioTests.svg" alt=""/></div>
	</div>
	<div *ngIf="!isTestRunning">
		<div class="big-text">{{ 'workflow.akustischeReaktion.ready' | translate }}</div>
	</div>
</div>
<div class="extrabuttons buttonrow replaceButtonrow">
	<div class="left-buttons"></div>
	<div class="right-buttons">
		<!--Vorwärts für Seiten einzelner Fragen-->
		<button nz-button nzType="primary" class="big-button right-one" (touchstart)="dispatchVitaReact($event)" (mousedown)="dispatchVitaReact($event)">
			{{ buttonText | translate }}
		</button>
	</div>
</div>
